export class ShareObjectViewModel {
    FromCompanyId: number;
    ToUserId: number;
    ObjectIds: number[];

    constructor(FromUserId: number, ToUserId: number, ObjectIds: number[])
    {
        this.FromCompanyId = FromUserId;
        this.ToUserId = ToUserId;
        this.ObjectIds = ObjectIds;
    }
}
